import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { AuthenticationService } from "./authentication.service";
import { SettingsService } from "./settings.service";
import { CRMStats } from "../_models/crmStats";
import { Report, BigData } from "../_models/report";


@Injectable()
export class ReportsService {

  
  public joinType = Object.freeze({ allCRM: 0, allAdwords: 1, innerJoin: 2 });
  public companyFilter = Object.freeze({ inzuzo: 0, enquiry: 1, all: 2 });
  public reportParams = { joinType: this.joinType.innerJoin, startDate: this.set.subMonth(new Date()), endDate: new Date() };
  public bigData = new BigData();
  

  constructor(private http: HttpClient, private auth: AuthenticationService,public set:SettingsService) {

  }

  loadDefault(minDate:Date,maxDate:Date) {
    return this.http.get(this.auth.baseUrl + 'api/Report1?minDate='+this.auth.dateParam(minDate)+"&maxDate="+this.auth.dateParam(maxDate), this.auth.getHeader())
      .map((res: Report[]) => { return res; });
  }
  loadDetail(minDate: Date, maxDate: Date,campaign:string) {
    return this.http.get(this.auth.baseUrl + 'api/ReportCampaignDate?minDate=' + this.auth.dateParam(minDate) + "&maxDate=" + this.auth.dateParam(maxDate)+'&campaign='+campaign, this.auth.getHeader())
      .map((res: Report[]) => { return res; });
  }
  loadDetailHour(minDate: Date, maxDate: Date, campaign: string) {
    return this.http.get(this.auth.baseUrl + 'api/ReportCampaignHour?minDate=' + this.auth.dateParam(minDate) + "&maxDate=" + this.auth.dateParam(maxDate) + '&campaign=' + campaign, this.auth.getHeader())
      .map((res: Report[]) => { return res; });
  }
  getAdvisers(token:any) {
    return this.http.post(this.auth.baseUrl + 'api/AdvisersA',token, this.auth.getHeader())
      .map((res: Report[]) => { return res; });
  }
  getMatches(token: any,days:number) {
    return this.http.post(this.auth.baseUrl + 'api/FLGIO', { Token: token, Days: days }, this.auth.getHeader())
      .map((res: Report[]) => { return res; });
  }
  uploadLead(match: any, token: any) {
    const upload = { Token: token, CRMId: match.ref, AdviserId: parseInt(match.adviser),AdviserName:match.adviserName,IsInzuzo:match.isInzuzo };
    return this.http.post(this.auth.baseUrl + 'api/CreateLead', upload, this.auth.getHeader())
      .map((res: any) => { return res; });
  }
}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/_services/reports.service.ts